import React from 'react';

export const BlockTabFilteredContainer = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'block-tab-filtered-container' */
            './ConnectedBlockTabFilteredContainer'
        ),
);
